import Vue from "vue"
import VueScroll from "vue-scroll"

Vue.use(VueScroll)
